export default class Video {

    handleVideo = () => {
        const videoHolders = document.querySelectorAll('.video-holder');

        if (videoHolders) {
            videoHolders.forEach((videoHolder) => {
                const link = videoHolder.querySelector('.play-icon');
                const video = videoHolder.querySelector('.video');
                const posterOverlay = videoHolder.querySelector('.poster-overlay')

                link.addEventListener('click', () => {
                    video.addEventListener("error", () => {
                        console.error("Error occurred while loading or playing the video.");
                        // You can display an error message or take appropriate action here.
                    });

                    video.play();

                    video.addEventListener("ended", () => {
                        posterOverlay.style.display = 'block';
                    });

                    video.addEventListener("pause", () => {
                        setTimeout(() => {
                            if (video.paused) {
                                link.style.display = 'flex';
                                posterOverlay.style.display = 'block';
                                video.removeAttribute('controls');
                            }
                        }, 100);
                    });

                    video.addEventListener("play", () => {
                        link.style.display = 'none';
                        posterOverlay.style.display = 'none';
                        video.setAttribute('controls', '');
                        link.classList.add('d-none');
                    });
                })

            })
        }

    }

    init() {
        this.handleVideo()
    }
}
